import React from 'react';

import { auth } from '../firebase';
import { Link } from 'react-router-dom';


const SignOutButton = () =>
      <li>
          <Link to="/" onClick={auth.doSignOut} >Sign out</Link>
      </li>


export default SignOutButton;



// WEBPACK FOOTER //
// ./src/components/SignOut.js